const today = new Date();

export const getLastWeeksDate = () => new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
